import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=2340865a&scoped=true&lang=pug&"
var script = {}
import style0 from "./modal.vue?vue&type=style&index=0&id=2340865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340865a",
  null
  
)

export default component.exports